export function getFilenameFromContentDisposition(contentDisposition) {
  if (!contentDisposition) return null;

  const utf8Match = contentDisposition.match(/filename\*\s*=\s*UTF-8''([^;]+)/i);
  if (utf8Match?.[1]) {
    return decodeURIComponent(utf8Match[1].trim());
  }

  const asciiMatch = contentDisposition.match(/filename\s*=\s*"?([^";]+)"?/i);
  if (asciiMatch?.[1]) {
    return asciiMatch[1].trim();
  }

  return null;
}

export function openBlobInNewTab(
  blob,
  { filename = null, cleanupAfterMs = 10 * 60 * 1000 } = {}
) {
  const fileOrBlob = filename ? new File([blob], filename, { type: blob.type }) : blob;
  const fileUrl = URL.createObjectURL(fileOrBlob);
  const newWindow = window.open(fileUrl, "_blank");

  if (!newWindow) {
    URL.revokeObjectURL(fileUrl);
    return false;
  }

  const cleanup = () => URL.revokeObjectURL(fileUrl);
  if (typeof newWindow.addEventListener === "function") {
    newWindow.addEventListener("beforeunload", cleanup, { once: true });
  }
  setTimeout(cleanup, cleanupAfterMs);
  return true;
}
